﻿import { demographicsEditorRecordsState, PatientRecordsSearchFilterFields, ColumnOptions, GridConfiguration, PatientRecordsSearchGridData } from './demographics-editor.model';

export const SEARCH_DEMOGRAPHICS_EDITOR_RECORDS = 'DEMOGRAPHICS_EDITOR_RECORDS';
export const GET_DEMOGRAPHICS_EDITOR_RECORDS = 'GET_DEMOGRAPHICS_EDITOR_RECORDS';
export const RESET_DEMOGRAPHICS_EDITOR_RECORDS_GRID_DATA = 'RESET_DEMOGRAPHICS_EDITOR_RECORDS_GRID_DATA';
export const RESET_DEMOGRAPHICS_EDITOR_RECORDS_TO_INITIAL_STATE = 'RESET_DEMOGRAPHICS_EDITOR_RECORDS_TO_INITIAL_STATE';


export const emptyString: string = "";
const patientRecordsSearchFilterFields: PatientRecordsSearchFilterFields = {
    lastName: emptyString,
    firstName: emptyString,
    dob: emptyString,
};

const columnOptions: ColumnOptions[] = [
    { header: 'Last Name', field: 'Last_Name', sortable: true },
    { header: 'First Name', field: 'First_Name', sortable: true },
    { header: 'Date of Birth', field: 'DOB', sortable: true }
];

export const gridConfiguration: GridConfiguration = {
    page: 1,
    pageSize: 5,
    sort: "Last_Name",
    order: 1
};
const patientRecordsSearchGridData: PatientRecordsSearchGridData = {
    rows: 5,
    rowsPerPageOptions: [5, 10, 20],
    cols: columnOptions,
    pageLinks: 3,
    configuration: gridConfiguration,
    filterData: [],
    totalRecords: 0
};

export const initialState: demographicsEditorRecordsState = {
    patientRecordsSearchFilterFields: patientRecordsSearchFilterFields,
    patientRecordsSearchGridData: patientRecordsSearchGridData
};